// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__16ZyJ","title":"ClientCherryInfo_title__3qaPk","itemText":"ClientCherryInfo_itemText__Grg4I"};